var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRoleLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.5C13.933 8.5 15.5 6.933 15.5 5C15.5 3.067 13.933 1.5 12 1.5C10.067 1.5 8.5 3.067 8.5 5C8.5 6.933 10.067 8.5 12 8.5ZM12 10C14.7614 10 17 7.76142 17 5C17 2.23858 14.7614 0 12 0C9.23858 0 7 2.23858 7 5C7 7.76142 9.23858 10 12 10ZM2.25 16C2.25 13.3766 4.37665 11.25 7 11.25H17C19.6234 11.25 21.75 13.3766 21.75 16V23C21.75 23.4142 21.4142 23.75 21 23.75C20.5858 23.75 20.25 23.4142 20.25 23V16C20.25 14.2051 18.7949 12.75 17 12.75H7C5.20507 12.75 3.75 14.2051 3.75 16V19C3.75 20.7949 5.20507 22.25 7 22.25H17C17.4142 22.25 17.75 22.5858 17.75 23C17.75 23.4142 17.4142 23.75 17 23.75H7C4.37665 23.75 2.25 21.6234 2.25 19V16ZM17.75 16C17.75 15.5858 17.4142 15.25 17 15.25C16.5858 15.25 16.25 15.5858 16.25 16V20C16.25 20.4142 16.5858 20.75 17 20.75C17.4142 20.75 17.75 20.4142 17.75 20V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoleLg);
export default __webpack_public_path__ + "static/media/userRoleLg.ed7d515c.svg";
export { ForwardRef as ReactComponent };